import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import cierreGeneralService from '../../services/cierreGeneralService';

export default function AccessModal({ open, onGranted, onClose }) {
  const [code, setCode] = useState('');
  const [status, setStatus] = useState({ loading: false, error: '' });
  const navigate = useNavigate();

  // Si el modal se abre, limpiamos el estado visual (pero NO borramos token automáticamente)
  useEffect(() => {
    if (open) {
      setStatus({ loading: false, error: '' });
      setCode('');
    }
  }, [open]);

  if (!open) return null;

  const handleVerify = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, error: '' });

    try {
      const data = await cierreGeneralService.verifyAccess(code);

      // ✅ Si no vino cgToken, marcamos error
      if (!data?.cgToken) {
        setStatus({
          loading: false,
          error: 'El servidor no devolvió token de acceso.'
        });
        return;
      }

      setStatus({ loading: false, error: '' });

      // ✅ Avisar acceso concedido
      if (typeof onGranted === 'function') onGranted();
      if (typeof onClose === 'function') onClose();
    } catch (err) {
      setStatus({
        loading: false,
        error: err?.message || 'ACCESO DENEGADO'
      });
    }
  };

  const handleClear = () => {
    cierreGeneralService.clearToken();
    setCode('');
    setStatus({ loading: false, error: '' });
  };

  const handleExit = () => {
    // No borra token automáticamente (solo cierra y sale)
    if (typeof onClose === 'function') onClose();
    navigate('/');
  };

  return (
    <div className="cg-modal-backdrop">
      <div className="cg-modal">

        {/* ❌ BOTÓN CERRAR / SALIR */}
        <button
          className="cg-modal-close"
          onClick={handleExit}
          title="Salir del Cierre General"
        >
          ✕
        </button>

        <div className="cg-modal-header">
          <h2 className="cg-title">Cierre General</h2>
          <p className="cg-subtitle">Ingrese el código de acceso para continuar.</p>
        </div>

        <form onSubmit={handleVerify} className="cg-modal-body">
          <label className="cg-label">Código de acceso</label>
          <input
            className="cg-input"
            type="password"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="••••"
            autoFocus
          />

          {status.error ? (
            <div className="cg-error">
              <strong>ACCESO DENEGADO</strong>
              <div className="cg-error-msg">{status.error}</div>
            </div>
          ) : null}

          <div className="cg-actions">
            <button
              type="submit"
              className="cg-btn cg-btn-primary"
              disabled={status.loading || !code.trim()}
            >
              {status.loading ? 'Verificando...' : 'Ingresar'}
            </button>

            <button
              type="button"
              className="cg-btn"
              onClick={handleClear}
              disabled={status.loading}
              title="Borra el token guardado y limpia el código"
            >
              Limpiar
            </button>
          </div>

          <div className="cg-hint">
            * Si no cuentas con el codigo, puedes presionar la X y te llevara al Dashboard.
          </div>
        </form>
      </div>
    </div>
  );
}
